import { createApp } from "vue";
import ObserveNavigation from "./observeNavigation"
/**
 * @type {{container: string, component: DefineComponent<any>, doNotObserve: boolean}[]}
 */
var VuecomponentList = [];
/**
 * @type {{App<Element>}[]}
 */
var activeApps = [];

/**
 * @param {{container: string, component: DefineComponent<any>, doNotObserve: boolean, props: object}} item 
 */
function initVueComponent(item) {
  let pagebottomTAG = item.container,
  pagebottomDOMs = document.querySelectorAll(pagebottomTAG);
  pagebottomDOMs.forEach((pagebottomDOM) => {
    if (pagebottomDOM) {
      let rawoptions = pagebottomDOM.getAttribute("data-settings"),
        options = {};
      if (rawoptions) {
        options = JSON.parse(rawoptions);
      }
      if(item.props) {
        var propKeys = Object.keys(item.props);
        propKeys.forEach(key => {
          if(options[key]) {
            options[key] = item.props[key];
          } else {
            options = {
              ...options,
              [key]: item.props[key]
            }
          }
        });
      }
      const app = createApp(item.component, { ...options });
      if (pagebottomTAG.startsWith(".")) {
        app.mount("#" + pagebottomDOM.id);
      } else {
        app.mount(item.container);
      }
      activeApps.push(app);
    }
  });
}

export default {
  /**
   * @param {{container: string, component: DefineComponent<any>, doNotObserve: boolean, props: object}[]} vuecomponentList 
   */
  initVue: function (vuecomponentList) {
    VuecomponentList = vuecomponentList;
    VuecomponentList.forEach((item) => {
      initVueComponent(item);
    });
    ObserveNavigation.setObservedVuecomponents(VuecomponentList);
  },

  /**
   * @param {string} id 
   */
  initComponent: function (id) {
    let item = VuecomponentList.find(({ container }) => container === id);
    if (item) {
      initVueComponent(item);
    }
  },

  /**
   * @param {string} id 
   */
  deleteOldComponent: function (id) {
    if (activeApps.length) {
      activeApps.forEach((app, index) => {
        if (app._container.id == id) {
          app.unmount();
          activeApps.splice(index, 1);
        } else if (app._container.classList.contains(id)) {
          app.unmount();
          activeApps.splice(index, 1);
        }
      });
    }
  },
};